import { toURLSafeBase64 } from '@precon-tools-suite-by-shared/js-utils';

export function filenameFromId(id: string): string {
    return toURLSafeBase64(id);
}
